import React from "react";
import RecipeSelector from "../structured-text/blocks/recipe-selector"
import useRecipeQuery from "../../hooks/use-recipe-query";

const ProductRecipes = (props) => {
  const recipes = useRecipeQuery();

  // Filter recipes based on relatedProducts containing props.originalId
  const filteredRecipes = recipes.filter(recipe =>
    recipe.relatedProducts.some(related => related.originalId === props.originalId)
  )

  if (filteredRecipes.length < 3) {
    // randomize the order of the recipes
    const moreRecipes = recipes.sort(() => 0.5 - Math.random()).filter(recipe =>
      recipe.brand === props.brand && recipe.originalId !== props.originalId
    )
    for (let i = 0; i < moreRecipes.length; i++) {
      if (filteredRecipes.length < 3) {
        filteredRecipes.push(moreRecipes[i])
      }
    }
  }

  if (filteredRecipes.length > 0) {
    return (
      <RecipeSelector title='Recipes to inspire you' items={filteredRecipes} brand={props.brand} />
    )
  }
}

export default ProductRecipes